<mat-toolbar>
    <div class="d-flex w-100 align-items">
      <div class="d-flex align-items-center">
        <div class="p-2">
          <img alt="Logo mzic" src="assets/images/mzic_main.svg" />
        </div>
        <p i18n class="title">
          {{title}}
        </p>
      </div>
    </div>
  </mat-toolbar>